<template>
  <div class="method">
    <div class="info">
      <div class="mr">
        <div class="mr__label" v-html="texts.address"></div>
        <div class="mr__value icon-label">
          <img :src="props.method.addressIcon" width="18" height="18" /><span
            class="opacity-50"
            >{{ props.method.address }}</span
          >
        </div>
      </div>
      <div class="mr">
        <div class="mr__label" v-html="texts.currency"></div>
        <div class="mr__value icon-label">
          <img :src="props.method.currencyIcon" width="18" height="18" /><span
            class="opacity-50"
            >{{ props.method.currency }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PreferredSvg from '~/assets/icons/preferred.svg?raw'
import EditSvg from '~/assets/icons/edit.svg?raw'
import DeleteSvg from '~/assets/icons/delete.svg?raw'
const props = defineProps({
  method: Object
})

const textsStore = useTextsStore()
const texts = computed(() => textsStore.account.billing.box_payment)

//TODO: Kamil - add set to preferred, edit and delete payment methods functionality

const setPreferred = () => {
  console.log('set preferred')
}

const editPayment = () => {
  console.log('edit payment')
}

const deletePayment = () => {
  console.log('delete payment')
}
</script>

<style lang="scss" scoped>
.method {
  border-radius: 10px;
  border: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
  background: var(--Box-bg, rgba(255, 255, 255, 0));
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 400px) {
    align-items: flex-start;
  }
}

.preferred {
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--Text, #000);
  background: var(--bubble-10, rgba(0, 0, 0, 0.1));
  border-radius: 5px;
  padding: 5px;
  line-height: 100%;
  margin-bottom: 10px;
}

.mr {
  display: flex;
  margin-bottom: 10px;
  font-size: 1.5rem;

  @media (max-width: 400px) {
    font-size: 1.4rem;
    flex-direction: column;
    gap: 5px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    width: 90px;
    opacity: 0.7;
  }
}

.options {
  width: 30px;
  height: 30px;
}
</style>
